import InputField from '../components/fields/InputField/InputField'

const fields = {
  firstName: {
    name: 'firstName',
    component: InputField,
    label: 'First name',
    autoComplete: 'off',
    fullWidth: true,
    required: true,
  },
  lastName: {
    name: 'lastName',
    component: InputField,
    label: 'Last name',
    autoComplete: 'off',
    fullWidth: true,
    required: true,
  },
  email: {
    name: 'email',
    component: InputField,
    label: 'Email',
    autoComplete: 'off',
    fullWidth: true,
    required: true,
  },
  phoneNumber: {
    name: 'phoneNumber',
    component: InputField,
    label: 'Enter your phone number',
    autoComplete: 'off',
    fullWidth: true,
    required: true,
  },
  companyName: {
    label: 'Enter your company name',
    type: 'input',
    name: 'companyName',
    component: InputField,
    autoComplete: 'off',
    fullWidth: true,
    required: true,
  },
}

export default fields
